/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateReportGroupDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivReportGroupControllerGetParamsGen,
  MrfiktivReportGroupViewModelGen,
  MrfiktivUpdateReportGroupDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ReportGroup<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags report group
   * @name ReportGroupControllerCreate
   * @summary (ReportGroup - CREATE) Create a ReportGroup
   * @request POST:/partner/{partnerId}/report-group
   * @secure
   * @response `201` `MrfiktivReportGroupViewModelGen` The created report group
   */
  reportGroupControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateReportGroupDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivReportGroupViewModelGen, any>({
      path: `/partner/${partnerId}/report-group`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags report group
   * @name ReportGroupControllerGet
   * @summary (ReportGroup - READ) Get all companies
   * @request GET:/partner/{partnerId}/report-group
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivReportGroupViewModelGen)[] })`
   */
  reportGroupControllerGet = (
    { partnerId, ...query }: MrfiktivReportGroupControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivReportGroupViewModelGen[] }, any>({
      path: `/partner/${partnerId}/report-group`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags report group
   * @name ReportGroupControllerGetOne
   * @summary (ReportGroup - READ) Get a report group
   * @request GET:/partner/{partnerId}/report-group/{reportGroupId}
   * @secure
   * @response `200` `MrfiktivReportGroupViewModelGen` The report group
   */
  reportGroupControllerGetOne = (partnerId: string, reportGroupId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivReportGroupViewModelGen, any>({
      path: `/partner/${partnerId}/report-group/${reportGroupId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags report group
   * @name ReportGroupControllerUpdate
   * @summary (ReportGroup - UPDATE) Updates a report group
   * @request PATCH:/partner/{partnerId}/report-group/{reportGroupId}
   * @secure
   * @response `201` `MrfiktivReportGroupViewModelGen` The updated report group
   */
  reportGroupControllerUpdate = (
    partnerId: string,
    reportGroupId: string,
    data: MrfiktivUpdateReportGroupDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivReportGroupViewModelGen, any>({
      path: `/partner/${partnerId}/report-group/${reportGroupId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags report group
   * @name ReportGroupControllerDelete
   * @summary (ReportGroup - DELETE) Deletes a report group
   * @request DELETE:/partner/{partnerId}/report-group/{reportGroupId}
   * @secure
   * @response `200` `MrfiktivReportGroupViewModelGen` The deleted report group
   */
  reportGroupControllerDelete = (partnerId: string, reportGroupId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivReportGroupViewModelGen, any>({
      path: `/partner/${partnerId}/report-group/${reportGroupId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
